import React from 'react';

// This assumes APP_VERSION is defined globally via Vite/DefinePlugin or similar, 
// but in previous files it seemed to be used as a variable or constant.
// If it's not defined, we should define it or import it.
// Checking SettingsPage.tsx imports: it was used but not imported?
// Ah, it might be a global variable. Let's assume it is or use a hardcoded value/import.
// Wait, looking at SettingsPage.tsx line 364: "v{APP_VERSION}".
// I need to check where APP_VERSION comes from.
// It's not in the imports of SettingsPage.tsx.
// It must be a global define. I'll declare it.

declare const APP_VERSION: string;

interface SettingsAppInfoProps {
    theme: 'light' | 'dark';
}

export const SettingsAppInfo: React.FC<SettingsAppInfoProps> = ({ theme }) => {
    return (
        <div className="flex flex-col items-center justify-center py-6 gap-1">
            <img src={theme === 'dark' ? "/header-dark.png" : "/header.png"} alt="Evenly Logo" className="h-10 w-auto object-contain" />
            <span className="text-[10px] font-mono font-medium text-text-faint bg-bg-card-alt px-1.5 py-0.5 rounded">
                v{APP_VERSION}
            </span>
        </div>
    );
};
